import { useState } from "react";
import { Tooltip } from "react-tooltip";
import WoSectionCard from "../common/WoSectionCard";
import { formatMoney } from "../documents/DocumentScanModals";
import Pos from "./Pos";

// Purchase Orders section as an independent card matching the proposals/forms
// look. The header carries the WO-level total of confirmed receipt amounts
// across all of its POs ("Purchase Orders | Total: $X (i)") instead of a
// count badge.
function WoPos({ woId, refreshToken, navigatePODetail, poEditHandle, onPreviewAttachments }) {
  const [count, setCount] = useState(0);
  const [total, setTotal] = useState(0);

  return (
    <WoSectionCard
      title="Purchase Orders"
      flush
      headerExtra={
        count > 0 && (
          <span className="ml-1 flex items-center gap-4 min-w-0">
            <span className="w-px h-4 bg-[#E5E8F3]" />
            <span className="flex items-center gap-2 min-w-0">
              <span className="font-OpenSansSemiBold text-[12px] leading-[18px] tracking-[0.12px] text-[#6A7282]">
                Total:
              </span>
              <span className="font-OpenSansSemiBold text-[14px] leading-[20px] tracking-[0.14px] text-[#1A2332]">
                {formatMoney(total)}
              </span>
              <img
                src="/images/common/tooltip.png"
                alt="info"
                data-tooltip-id="po-total-tooltip"
                data-tooltip-html="Sum of confirmed receipt amounts across this work order's purchase orders.<br/>Receipts marked Needs Review are not included."
                className="w-3 h-3"
                onClick={(e) => e.stopPropagation()}
              />
              <Tooltip id="po-total-tooltip" positionStrategy="fixed" />
            </span>
          </span>
        )
      }
    >
      <Pos
        woId={woId}
        refreshToken={refreshToken}
        navigatePODetail={navigatePODetail}
        poEditHandle={poEditHandle}
        onPreviewAttachments={onPreviewAttachments}
        onCount={setCount}
        onTotal={setTotal}
      />
    </WoSectionCard>
  );
}

export default WoPos;
